import { Component, Input } from '@angular/core';
import { FileUtils } from '../../../shared';
import { Faculty, Queue } from '../../../models';

@Component({
    selector: 'qms-tile',
    templateUrl: './tile.component.html',
    styleUrls: ['tile.component.css']
})
export class TileComponent {
    @Input() public model: Faculty | Queue;

    public getLogo() {
        return FileUtils.getImageBase64Format(this.model.logo, this.model.logoContentType);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/generic/tile/tile.component.ts